<template>
  <div class="products-settlement-page-content flex flex-col items-center w-full text-left">
    <!-- banner 包含移动端 -->
    <PageBanner :content="content.bannerInfo" />

    <PageBusinessRow :content="content.businessIntroduction" />

    <!-- 产品功能介绍 中间左右布局的内容 -->
    <PageFunction :content="content.featuresIntroduction" />

    <!-- 产品优势 -->
    <PageAdvantage :content="content.advantage" :extraTitleStyle="{ color: '#272E3B' }" />

    <SiteMap />
  </div>

</template>

<script setup lang="ts">
import { ref, shallowReactive, onMounted, onUnmounted } from 'vue'
import { useSeoMeta } from 'nuxt/app'
const title = '和贵结算中心'
const description = '以全链路能力提供高效精准的资金管理业务支撑解决方案'
useSeoMeta({
  title,
  description,
})

const content = shallowReactive({
  bannerInfo: {
    banner: '/images/pages/products/settlement/banner.png',
    mobileBanner: '/images/mobile/products/hgjszx.png'
  },
  businessIntroduction: {
    title: '产品业务介绍',
    description: [
      '企业结算中心以提供统一高效支付结算体验为核心，通过自动化处理简化对账、缩短周期，提升操作效率与资金安全性；同时支持多元支付及合规票据管理，助力客户优化资金利用、降低财务成本，并以数据洞察支撑经营决策，强化合作粘性。',
    ],
    descImage: '/images/pages/products/settlement/c.png',
  },
  featuresIntroduction: {
    title: '产品功能介绍',
    desc: '',
    extraCardBackColor: 'bg-#EFF8FF',
    extraTitleClass: 'bg-#EFF8FF w-100%!',
    groups: [
      {
        title: '应用管理',
        desc: '',
        descList: [
          '统一管理接入结算中心的业务系统',
        ],
        icon: '/images/pages/products/settlement/f-i- (1).png',
        mainImage: '/images/pages/products/settlement/f- (1).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '渠道管理',
        desc: '',
        descList: ['统一管理银行、第三方支付等多元渠道',],
        icon: '/images/pages/products/settlement/f-i- (5).png',
        mainImage: '/images/pages/products/settlement/f- (2).png',
        direction: 'copywriting-to-image'
      },
      {
        title: '进件管理',
        desc: '',
        descList: ['集中管理商户/供应商入驻资料，自动化审核与信息变更同步，提升合作方接入效率'],
        icon: '/images/pages/products/settlement/f-i- (3).png',
        mainImage: '/images/pages/products/settlement/f- (3).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '交易明细',
        desc: '',
        descList: ['实时记录每笔支付与退款订单状态、金额、时间及关联业务单号，支持按条件筛选与导出',],
        icon: '/images/pages/products/settlement/f-i- (4).png',
        mainImage: '/images/pages/products/settlement/f- (4).png',
        direction: 'copywriting-to-image'
      },
      {
        title: '分账结算',
        desc: '',
        descList: ['根据业务系统结算数据自动分账，可以按日查看每次分账记录和明细',],
        icon: '/images/pages/products/settlement/f-i- (2).png',
        mainImage: '/images/pages/products/settlement/f- (5).png',
        direction: 'image-to-copywriting'
      },
      {
        title: '账户流水',
        desc: '',
        descList: ['记录资金变动的核心数据，用于追踪每一笔资金的来源、去向及时间',],
        icon: '/images/pages/products/settlement/f-i- (6).png',
        mainImage: '/images/pages/products/settlement/f- (6).png',
        direction: 'copywriting-to-image'
      }, {
        title: '多维度对账',
        desc: '',
        descList: ['自动和业务系统及第三方渠道比对交易流水、结算明细，智能标记差异项',],
        icon: '/images/pages/products/settlement/f-i- (7).png',
        mainImage: '/images/pages/products/settlement/f- (7).png',
        direction: 'image-to-copywriting'
      }, {
        title: '提现记录',
        desc: '',
        descList: ['提供多维度资金余额查询，支持查看每一笔提现记录'],
        icon: '/images/pages/products/settlement/f-i- (8).png',
        mainImage: '/images/pages/products/settlement/f- (8).png',
        direction: 'copywriting-to-image'
      },
    ]
  },
  advantage: {
    title: '产品优势',
    background: '/images/pages/products/settlement/b-back.png',
    list: [
      {
        briefBack: '/images/pages/products/settlement/b-b- (4).png',
      },
      {
        briefBack: '/images/pages/products/settlement/b-b- (1).png',
      },
      {
        briefBack: '/images/pages/products/settlement/b-b- (2).png',
      },
      {
        briefBack: '/images/pages/products/settlement/b-b- (3).png',
      },
    ]
  }
})

</script>

<style scoped lang="scss">
@import "@base/@core/scss/template/libs/vuetify/variables";

.products-settlement-page-content {
  max-width: $page-max-width;
  background-color: #fff;

  @media (max-width: 1023.9px) {
    padding-top: $table-header-height;
  }

  .settlement-business-number-cooperative-stores {
    position: absolute;
    top: 120px;
    right: 0;
    display: flex;
    width: 16.5rem;
    height: 5.32rem;
    padding-top: 20px;
    padding-left: 30px;
    border-radius: 0;
    background-image: url("/images/pages/products/settlement/Frame 2147229605@2x.png");
    background-size: cover;
  }

  .features-group-ul {
    .features-group-li {
      position: relative;
      padding-left: 2rem;

      &::before {
        position: absolute;
        z-index: 0;
        top: 5px;
        left: 0;
        width: 19px;
        height: 19px;
        background-image: url("/images/pages/products/settlement/圆点.png");
        background-size: cover;
        content: "";
      }
    }
  }
}

.settlement-product-advantage {
  background-image: url("/images/pages/products/settlement/product_bottom_next.png");
  background-size: cover;
}

.accordion-container {
  display: flex;
  height: 300px;
  gap: 1rem;

  .accordion-item {
    overflow: hidden;
    flex: 1;
    cursor: pointer;
    transition: all 1s ease;

    &:hover,
    &.active {
      flex: 3;
    }

    :deep(img) {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 1s ease;
    }

    &:not(.active):hover :deep(img) {
      // transform: scale(1.05);
    }
  }
}
</style>
